import { w as withConfigTransport } from "../../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaTimePickerColumn } from "./VaTimePickerColumn-1745a9c4.mjs";
const VaTimePickerColumn = withConfigTransport(_VaTimePickerColumn);
export {
  VaTimePickerColumn as V
};
//# sourceMappingURL=index-7df1978b.mjs.map
